import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import QuickLinks from "./quick_links";
import Announcements from "./announcements";
import RecentHires from "./recent_hires";

function Home() {
  const Navigate = useNavigate()
  useEffect(() => {
    Navigate('/customers')
  }, []);

  return (
    false ? <main class="-mt-24 pb-8">
      <div class="mx-auto max-w-3xl  py-3 px-4 sm:px-6 lg:max-w-[86rem] lg:px-8">
        <h1 class="sr-only">Profile</h1>
        <div class="grid grid-cols-1 items-start gap-4 lg:grid-cols-3 lg:gap-8">
          <div class="grid grid-cols-1 gap-4 lg:col-span-2">
            <section aria-labelledby="profile-overview-title">
              <div class="overflow-hidden rounded-lg bg-white shadow">
                <h2 class="sr-only" id="profile-overview-title">
                  Profile Overview
                </h2>
                <div class="bg-white p-6">
                  <div class="sm:flex sm:items-center sm:justify-between">
                    <div class="sm:flex sm:space-x-5">
                      <div class="flex-shrink-0">
                        <img
                          class="mx-auto h-20 w-20 rounded-full"
                          src={
                            "https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=facearea&amp;facepad=2&amp;w=256&amp;h=256&amp;q=80"
                          }
                          alt=""
                        />
                      </div>
                      <div class="mt-4 text-center sm:mt-0 sm:pt-1 sm:text-left">
                        <p class="text-sm font-medium text-gray-600">
                          Welcome back,
                        </p>
                        <p class="text-xl font-bold text-gray-900 sm:text-2xl">
                          Chelsea Hagon
                        </p>
                        <p class="text-sm font-medium text-gray-600">
                          Human Resources Manager
                        </p>
                      </div>
                    </div>
                    <div class="mt-5 flex justify-center sm:mt-0">
                      <Link class="flex items-center justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                        View profile
                      </Link>
                    </div>
                  </div>
                </div>
                <div class="grid grid-cols-1 divide-y divide-gray-200 border-t border-gray-200 bg-gray-50 sm:grid-cols-3 sm:divide-x sm:divide-y-0">
                  <div class="px-6 py-5 text-center text-sm font-medium">
                    <span class="text-gray-900">12</span>
                    <span class="text-gray-600">Vacation days left</span>
                  </div>
                  <div class="px-6 py-5 text-center text-sm font-medium">
                    <span class="text-gray-900">4</span>
                    <span class="text-gray-600">Sick days left</span>
                  </div>
                  <div class="px-6 py-5 text-center text-sm font-medium">
                    <span class="text-gray-900">2</span>
                    <span class="text-gray-600">Personal days left</span>
                  </div>
                </div>
              </div>
            </section>

            <section aria-labelledby="quick-links-title">
              <div class="divide-y divide-gray-200 overflow-hidden rounded-lg bg-gray-200 shadow sm:grid sm:grid-cols-2 sm:gap-px sm:divide-y-0">
                <QuickLinks ></QuickLinks>
              </div>
            </section>
          </div>

          <div class="grid grid-cols-1 gap-4">
            <section aria-labelledby="announcements-title">
              <Announcements> </Announcements>
            </section>

            <section aria-labelledby="recent-hires-title">
              <RecentHires> </RecentHires>
            </section>
          </div>
        </div>
      </div>
    </main>: <></>
  );
}

export default Home;
